import styled from 'styled-components';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import { cells } from '../../../styling/utils/grid';
import { getColor } from '../../../styling/mixins/colors';


export const StyledBrandsSection = styled.section`
    padding-top: 2.4rem;
    padding-bottom: 3.2rem;

    ${breakpoint('medium')} {
      padding-top: 3.2rem;
      padding-bottom: 4rem;
    }

    ${breakpoint('large')} {
      padding-top: 4rem;
      padding-bottom: 4.8rem;
    }

  .brand-block {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2.4rem;
    }

    &__list {
      align-items: center;
      gap: 4px;
      ${cells(2)}

      ${breakpoint('medium')} {
        ${cells(3)}
      }

      ${breakpoint('large')} {
        ${cells(6)}
      }

      &--item {
        background-color: ${getColor('white')};
        border: solid 1px ${getColor('grey', 100)};
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px;
      }
    }

    &__text {
        line-height: 33px;
    }
  }
`;